import { Controller } from "@hotwired/stimulus"
import { Sortable } from "sortablejs"

// A turbo-stream GET, as the "Abschließen" button makes it: Turbo also follows its redirect to
// the closing report when the tenant has one.
function openCompletion(href) {
  const link = document.createElement("a")
  link.href = href
  link.dataset.turboStream = ""
  link.hidden = true
  document.body.append(link)
  link.click()
  link.remove()
}

export default class extends Controller {
  static targets = ["column", "item"]
  initialize() {}
  connect() {
    if (this.hasItemTarget) {
      this.columnTargets.forEach((column) => {
        // Where the card sat before the drag. `oldIndex` cannot restore it: after a move up
        // within the same column, children[oldIndex] is the card that used to sit above it.
        let originNextSibling = null
        new Sortable(column, {
          draggable: "li",
          group: "shared",
          animation: 250,
          delay: 75,
          delayOnTouchOnly: true,
          ghostClass: "border-2",
          onStart: function (event) {
            originNextSibling = event.item.nextElementSibling
          },
          onEnd: function (event) {
            const url = event.item.getAttribute("data-url")
            const column = event.to.getAttribute("data-column")
            // Puts the card back where it was. Captured now: the request below is async and
            // another drag may start before it answers.
            const anchor = originNextSibling
            const revert = () =>
              event.from.insertBefore(event.item, anchor?.parentNode === event.from ? anchor : null)
            // Erledigt goes through "Abschließen" (Abschlussdaten or the closing report): the
            // card goes back and the closing panel opens for the column it was dropped on.
            if (event.to.dataset.category === "done" && event.item.dataset.closed !== "true") {
              revert()
              openCompletion(`${event.item.dataset.completeUrl}?column_id=${column}`)
              return
            }
            const data = { task: { column_id: column, position: event.newIndex + 1 } }
            const token = document.head
              .querySelector('meta[name="csrf-token"]')
              .getAttribute("content")
            // A refused move (no permission to close, invalid task) reverts; a turbo-stream
            // answer carries the flash that says why.
            fetch(url, {
              method: "PATCH",
              credentials: "same-origin",
              headers: {
                "X-CSRF-Token": token,
                Accept: "text/vnd.turbo-stream.html, application/json",
                "Content-type": "application/json",
              },
              body: JSON.stringify(data),
            })
              // Success answers JSON. A refusal answers a turbo-stream flash — with status 200
              // (ApplicationController#account_not_authorized) — so the type decides, not `ok`.
              .then(async (response) => {
                const type = response.headers.get("Content-Type") || ""
                if (response.ok && type.includes("json")) return response.json()

                revert()
                if (type.includes("turbo-stream")) Turbo.renderStreamMessage(await response.text())
                return null
              })
              .then((data) => {
                const hoursElement = document.getElementById("new_scheduled_hours")
                if (data && hoursElement) {
                  const hours = data.hours.toString().replace(".", ",")
                  hoursElement.innerHTML = `${hours} Stunden`
                }
              })
          },
        })
      })
    }
  }
  disconnect() {}
}
